<template>
  <div id="app">
    <!-- transition组件包裹router-view -->
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
  /* 动画持续0.5秒，可以根据需求调整 */
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
